/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Dialog_ConfirmInputs */

const en_input_position_dialog_confirm = /** @type {(inputs: Input_Position_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Position`)
};

const fr_input_position_dialog_confirm = /** @type {(inputs: Input_Position_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définir la Position`)
};

const de_input_position_dialog_confirm = /** @type {(inputs: Input_Position_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position einstellen`)
};

const it_input_position_dialog_confirm = /** @type {(inputs: Input_Position_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta posizione`)
};

const ru_input_position_dialog_confirm = /** @type {(inputs: Input_Position_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Установить позицию`)
};

const es_input_position_dialog_confirm = /** @type {(inputs: Input_Position_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establecer posición`)
};

const zh_cn2_input_position_dialog_confirm = /** @type {(inputs: Input_Position_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置位置`)
};

const ja_input_position_dialog_confirm = /** @type {(inputs: Input_Position_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置を設定する`)
};

const hi_input_position_dialog_confirm = /** @type {(inputs: Input_Position_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति निर्धारित करें`)
};

const pt_pt2_input_position_dialog_confirm = /** @type {(inputs: Input_Position_Dialog_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição definida`)
};

/**
* | output |
* | --- |
* | "Set Position" |
*
* @param {Input_Position_Dialog_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_dialog_confirm = /** @type {((inputs?: Input_Position_Dialog_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Dialog_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_dialog_confirm(inputs)
	if (locale === "de") return de_input_position_dialog_confirm(inputs)
	if (locale === "it") return it_input_position_dialog_confirm(inputs)
	if (locale === "ru") return ru_input_position_dialog_confirm(inputs)
	if (locale === "es") return es_input_position_dialog_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_dialog_confirm(inputs)
	if (locale === "ja") return ja_input_position_dialog_confirm(inputs)
	if (locale === "hi") return hi_input_position_dialog_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_dialog_confirm(inputs)
	return en_input_position_dialog_confirm(inputs)
});